import './mustardseed2/style';
import FormStructure from './mustardseed2/form_structure';

export default FormStructure;